import type { BoardColumn } from "~/shared/types/quote-board-types.ts";

export const getBrowserAvailableWidth = (): number => {
	if (globalThis.window == undefined) {
		return 1200; // SSR-safe default
	}
	return window.innerWidth;
};

export const distributeVisibleColumnWidths = (
	columns: BoardColumn[],
	availableWidth: number,
): BoardColumn[] => {
	const visible = columns.filter((c) => c.show);

	// Subtract fixed-width columns from the available space before distributing.
	const fixedWidthTotal = visible
		.filter((c) => c.fixedWidth)
		.reduce((sum, c) => sum + (typeof c.width === "number" ? c.width : 0), 0);

	const distributable = visible.filter((c) => !c.fixedWidth);
	const totalWeight = distributable.reduce(
		(sum, c) => sum + (typeof c.width === "number" ? c.width : 100),
		0,
	);

	const remainingWidth = availableWidth - fixedWidthTotal;
	const defaultMinColWidth = 50;

	return columns.map((col) => {
		if (!col.show || col.fixedWidth) {
			// Hidden or fixed-width columns keep their original width.
			return { ...col };
		}
		const weight = typeof col.width === "number" ? col.width : 100;
		const minColWidth = col.minWidth ?? defaultMinColWidth;
		const computed = Math.max(
			minColWidth,
			Math.floor((remainingWidth * weight) / Math.max(1, totalWeight)),
		);
		return { ...col, width: computed };
	});
};
